export function scrollButton() {
  const scrollButton = document.getElementById('scroll-button');
  document.addEventListener('scroll', function () {
    const scrollY = window.pageYOffset;
    if (scrollY > 200) {
      scrollButton.style.opacity = "1";
    } else {
      scrollButton.style.opacity = "0";
    }
  })
  scrollButton.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  })
}